import { render } from "./privacy.vue?vue&type=template&id=e6c1e3fe&scoped=true"
const script = {}

import "./privacy.vue?vue&type=style&index=0&id=e6c1e3fe&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6c1e3fe"]])

export default __exports__